import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import {
  DEFAULT_LANGUAGE,
  LANGUAGE_STORAGE_KEY,
  SUPPORTED_LANGUAGES,
} from 'constants/language';

import enTranslations from '../locales/en.json';
import ruTranslations from '../locales/ru.json';

const getInitialLanguage = () => {
  try {
    const storedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY);

    if (storedLanguage && SUPPORTED_LANGUAGES.includes(storedLanguage as 'en' | 'ru')) {
      return storedLanguage;
    }
  } catch {
    // localStorage may be unavailable in tests or SSR.
  }

  return DEFAULT_LANGUAGE;
};

i18n.use(initReactI18next).init({
  lng: getInitialLanguage(),
  fallbackLng: 'en',
  resources: {
    en: {
      translation: enTranslations,
    },
    ru: {
      translation: ruTranslations,
    },
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
